import type { FunctionComponent } from 'react';
import { SchoolCatchmentMapBrick } from './SchoolCatchmentMapBrick';
import { useSchoolPageBySlugTabContentQuery } from '../../../../graphql/useSchoolPageBySlugTabContentQuery';
import { isContentOverview } from '../../../../helpers/isContentOverview';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';

export const SchoolCatchmentMapBrickWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugTabContentQuery();
  const tabContent = data?.schoolPageBySlug?.tabContent;
  if (!tabContent || !isContentOverview(tabContent)) return null;

  const { schoolCatchmentMap } = tabContent;
  if (!schoolCatchmentMap) return null;
  const { pins, title, tracking } = schoolCatchmentMap;
  const catchmentZones = tabContent.schoolCatchmentMap?.schoolCatchment;

  return (
    <ContentBrick title={title}>
      <SchoolCatchmentMapBrick
        schoolPin={pins?.[0]?.coordinates}
        catchmentZones={catchmentZones}
        tracking={tracking}
      />
    </ContentBrick>
  );
};
